import axios from 'axios';

export const client = axios.create({
  baseURL: process.env.VITE_API_URL
});

export const clientServer = axios.create({
  baseURL: process.env.VITE_SERVER_URL
});
